/** App config. */
export const appConfig = {

  // Must set value manually from the browser to be able to getItem here
  isDevelopment: localStorage.getItem('mode') === 'development',

  environment: process.env.MIX_ENVIRONMENT,

  apiUrl: process.env.MIX_API_URL ?? window.location.origin,
  authorizeNetLoginId: process.env.MIX_AUTHORIZE_NET_LOGIN_ID,
  authorizeNetClientKey: process.env.MIX_AUTHORIZE_NET_CLIENT_KEY,
  applePayMerchantId: process.env.MIX_APPLE_MERCHANT_ID,

  paypal: {
    client_id: process.env.MIX_PAYPAL_CLIENT_ID,
    paypal_currency: process.env.MIX_PAYPAL_CURRENCY,
  },
};
